export default [
  {
    path: "quality/collar-stock",
    name: "CollarStock",
    component: () => import("@/pages/quality/CollarStock.vue"),
    meta: {
      title: "领标库存管理",
      requireAuth: true,
    },
  },
  {
    path: "quality/repair",
    name: "PcRepair",
    component: () => import("@/pages/quality/PcRepair.vue"),
    meta: {
      title: "pc修复",
      requireAuth: true,
    },
  },
  {
    path: "quality/repair-list",
    name: "PcRepairList",
    component: () => import("@/pages/quality/PcRepairList.vue"),
    meta: {
      title: "修复列表",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/quality.js